import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { GSMIcon } from '../index';
import { GSMTooltip } from './tooltip';
import { useHelpPopup } from 'shared/hooks/ui/help-popup';
export const GSMIconWithInfo = memo(function GSMIconWithInfo(props) {
    const { device_id, ...rest } = props;
    const [HelpPopup, open] = useHelpPopup();
    return (_jsxs(_Fragment, { children: [_jsx(GSMIcon, { device_id: device_id, open: open, ...rest }), _jsx(GSMTooltip, { Tooltip: HelpPopup, device_id: device_id })] }));
});
